import { useEffect, useRef } from 'react';
import { useResizeObserverRef } from '../../../hooks/useResizeObserver'; // Import the hook

export default function useZoomResizeObserver(dialogRef, centerDialog) {
  const animationFrameId = useRef(null);
  const resizeTimeout = useRef(null);
  const isObserverAttached = useRef(false); // Tracks whether observer is attached

  const observerCallback = () => {
    clearHandles();
    animationFrameId.current = window.requestAnimationFrame(() => {
      centerDialog();
      resizeTimeout.current = window.setTimeout(() => {
        setObserverRef(null); // Disconnect observer after small delay
        isObserverAttached.current = false;
      }, 100);
    });
  };
  const clearHandles = () => {
    if (animationFrameId.current) {
      window.cancelAnimationFrame(animationFrameId.current);
      animationFrameId.current = null;
    }
    if (resizeTimeout.current) {
      clearTimeout(resizeTimeout.current);
      resizeTimeout.current = null;
    }
  };
  const [setObserverRef] = useResizeObserverRef(observerCallback);
  useEffect(() => {
    const dialog = dialogRef.current;
    if (!dialog) return;
    const handleWindowResize = () => {
      clearHandles();
      if (isObserverAttached.current) {
        setObserverRef(null);
      }
      setObserverRef(dialog); // Attach observer only after resize
      isObserverAttached.current = true;
    };
    window.addEventListener('resize', handleWindowResize);
    return () => {
      window.removeEventListener('resize', handleWindowResize);
      setObserverRef(null);
      clearHandles();
    };
  }, [centerDialog, dialogRef, setObserverRef]);
}
//# sourceMappingURL=useZoomResizeObserver.js.map